module.exports = __webpack_public_path__ + "static/media/combined~zvjsGWFa.a2807f43.svg";